<adaa-auth-layout>
    @if (forgetPasswordForm(); as passwordForm) {
        @if (!resetDone()) {
            <form [formGroup]="passwordForm" (ngSubmit)="submit()">
                <div class="adaa-auth-subtitle">{{ "login.forgot_password_title" | translate }}</div>
                <p class="adaa-auth-text">{{ "login.forgot_text" | translate }}</p>

                <div class="adaa-auth-field">
                    <adaa-form-input
                        [required]="true"
                        [placeholder]="'common.form.label.email' | translate"
                        controlName="email"
                        formControlName="email"
                        inputType="email"
                        [invalid]="passwordForm.get('email')?.errors?.['required'] || passwordForm.get('email')?.errors?.['email']"
                    ></adaa-form-input>
                </div>

                <button type="submit" class="adaa-auth-btn adaa-auth-btn-primary">{{ "login.reset_password" | translate }}</button>
                <button type="button" class="adaa-auth-btn adaa-auth-btn-ghost" [routerLink]="'/login'">{{ "login.go_back" | translate }}</button>
            </form>
        } @else {
            <div class="adaa-auth-status">
                <div class="adaa-auth-status-icon adaa-auth-status-icon--success">
                    <i class="fa-solid fa-check"></i>
                </div>
                <p class="adaa-auth-text" style="margin-bottom: 6px">{{ "login.send_reset_email_text" | translate }}</p>
                <p class="adaa-auth-status-email">{{ passwordForm.get("email")?.value }}</p>
                <p class="adaa-auth-text">{{ "login.send_reset_email_instructions" | translate }}</p>
                <button type="button" class="adaa-auth-btn adaa-auth-btn-ghost" [routerLink]="'/login'">{{ "login.go_back" | translate }}</button>
            </div>
        }
    }
</adaa-auth-layout>
